import Dialog, { Props as DialogProps } from 'components/Dialog';
import LoadingIndicator from 'components/LoadingIndicator';
import * as React from 'react';

/**
 * ## Loading indicator that uses [Modal](/internal/components/Modal) behavior to take over the whole viewport.
 *
 *
 * ```example
 * <ModalTrigger modal={<LoadingModal />}>
 *   <Button>Show LoadingModal</Button>
 * </ModalTrigger>
 * ```
 */

const LoadingModal = ({ ...props }: DialogProps) => (
  <Dialog {...props} box={false} hideCloseButton className="LoadingModal">
    <LoadingIndicator align="center" />
  </Dialog>
);

export default LoadingModal;
